import { render } from "./MessageForm.vue?vue&type=template&id=8328132a"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__